import React from 'react'
import {Icon} from 'react-weui'
import RefundContentEditable from './refundContentEditable'
import '../../css/page/refundComponent.css'

class RefundReject extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            selectIndex: 0,
            reason: '学员已听课',
        }
    }

    render() {
        const {isShow, data} = this.props;
        const title = data ? `拒绝${data.account_info.nickname}的退款?`:''
        return (
            <div>
                {isShow ?
                    <div className="modal-refund">
                        <div className="refund-dialog">
                            <div className="refund-dialog-body">
                                <div className="refund-dialog-title">
                                    {title}
                                </div>
                                <div className="refund-dialog-body-form">
                                    <span className="refund-radio-selectItem"
                                          onClick={() => this.setState({selectIndex: 0, reason: '学员已听课'})}>
                                        <Icon value="success"
                                              className={this.state.selectIndex === 0 ? 'checked-status' : 'unchecked-status'}/>
                                        <p>学员已听课</p>
                                    </span>
                                    <span className="refund-radio-selectItem"
                                          onClick={() => this.setState({selectIndex: 1, reason: '学员个人原因'})}>
                                        <Icon value="success"
                                              className={this.state.selectIndex === 1 ? 'checked-status' : 'unchecked-status'}/>
                                        <p>学员个人原因</p>
                                    </span>

                                    <span className="refund-radio-selectItem"
                                          onClick={() => this.setState({selectIndex: 2, reason: ''})}>
                                        <Icon value="success"
                                              className={this.state.selectIndex === 2 ? 'checked-status' : 'unchecked-status'}/>
                                        <p>其他</p>
                                    </span>

                                    {this.state.selectIndex === 2 &&
                                    <RefundContentEditable onChange={val => this.setState({reason: val})}
                                                           limitNum={200}/>}
                                </div>

                            </div>
                            <div className="btnGroup">
                                <span className="btnLeft" onClick={() => this.props.clickHandle.handleClose()}>取消</span>
                                <span className="btnRight"
                                      onClick={() => this.props.clickHandle.handleReject(this.state.reason)}>确定</span>
                            </div>
                        </div>
                    </div>
                    : null}
            </div>
        )
    }
}

export default RefundReject


// WEBPACK FOOTER //
// ./src/pages/refund/refundReject.js